import { Tag } from "antd"
import { notifications } from "notifications"
import { CopyOutlined } from "@ant-design/icons"
import { NativeGame } from "../store/types"

export const nativeGamesControlColumns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    render: (id: string) => {
      return (
        <div
          onClick={() => {
            navigator.clipboard.writeText(id)
            notifications.success("Copied id:" + id)
          }}
          style={{
            background: "#A3A3A3",
            width: 24,
            height: 24,
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          <CopyOutlined
            style={{ color: "white", display: "flex", transform: "translate(5px, 2px)" }}
          />
        </div>
      )
    },
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Platforms",
    key: "platforms",
    render: (_: unknown, record: NativeGame) => (
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
        {(record.platforms ?? []).map(p => (
          <Tag key={p.platform} color={p.isInstallable ? "green" : "default"}>
            {p.platform}: {p.platformId}
          </Tag>
        ))}
        {(record.platforms?.length ?? 0) === 0 && <span>-</span>}
      </div>
    ),
  },

  {
    title: "Category",
    dataIndex: "category",
    key: "category",
  },
]

export const nativeGameDetailsColumns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Reward (USD)",
    dataIndex: "rewardUsd",
    key: "rewardUsd",
    render: (value: number | null | undefined) => value != null ? `$${value}` : "-",
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
  },
  {
    title: "Ads Required",
    dataIndex: "adsWatchedTotalRequired",
    key: "adsWatchedTotalRequired",
    render: (value: number | null | undefined) => value ?? "-",
  },
]
